import facebookImage from '../../../assets/images/icons/facebook.svg';
import instagramImage from '../../../assets/images/icons/instagram.png';
import linkedInImage from '../../../assets/images/icons/linkedin.png';
import twitterImage from '../../../assets/images/icons/twitter.svg';
import UserProfileData from '../../../types/userProfileData';

interface SocialLinkButtonsProps {
  userProfile: UserProfileData;
}

export default function SocialLinkButtons({ userProfile }: SocialLinkButtonsProps) {
  const socialData = [
    { id: 1, image: instagramImage, link: userProfile.instagram },
    { id: 2, image: facebookImage, link: userProfile.facebook },
    { id: 3, image: linkedInImage, link: userProfile.linkedIn },
    { id: 4, image: twitterImage, link: userProfile.twitter },
  ];
  const SocialLinks = socialData
    .filter(social => social.link)
    .map(social => {
      return (
        <a href={social.link!} key={social.id} target="_blank" rel="noreferrer">
          <img className="social-link-image" src={social.image} alt="" />
        </a>
      );
    });
  return <div className="social-links-container">{SocialLinks}</div>;
}
